import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

function MovingService() {
  const services = [
    'Kompletter Umzugsservice',
    'Verpackungsmaterial und -service',
    'Möbelmontage und -demontage',
    'Transport und Logistik',
    'Einlagerung und Zwischenlagerung',
    'Endreinigung der alten Wohnung',
    'Renovierungsarbeiten',
    'Behördengänge und Ummeldungen'
  ];

  return (
    <Box sx={{ 
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0a1f28 0%, #162a34 50%, #1c3440 100%)'
    }}>
      <Container maxWidth="lg" sx={{ pt: 12, pb: 6 }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <LocalShippingIcon sx={{ fontSize: 60, color: '#55d6dc', mb: 2 }} />
          <Typography variant="h2" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
            Umzugsservice
          </Typography>
          <Typography variant="h5" sx={{ color: '#55d6dc' }}>
            Ihr professioneller Partner für stressfreie Umzüge
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card sx={{ bgcolor: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
              <CardContent>
                <Typography variant="h4" sx={{ color: 'white', mb: 3 }}>
                  Unser Leistungsspektrum
                </Typography>
                <List>
                  {services.map((service, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ color: '#55d6dc' }} />
                      </ListItemIcon>
                      <ListItemText 
                        primary={service}
                        sx={{ color: 'white' }}
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ bgcolor: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
              <CardContent>
                <Typography variant="h4" sx={{ color: 'white', mb: 3 }}>
                  Warum H&N Umzugsservice?
                </Typography>
                <Typography variant="body1" sx={{ color: 'white', mb: 2 }}>
                  Mit über 10 Jahren Erfahrung im Umzugsgeschäft bieten wir Ihnen einen 
                  zuverlässigen und professionellen Service. Unser geschultes Team sorgt 
                  dafür, dass Ihr Umzug reibungslos und stressfrei verläuft.
                </Typography>
                <Typography variant="body1" sx={{ color: 'white', mb: 2 }}>
                  Von der ersten Beratung bis zur letzten Box - wir sind für Sie da. 
                  Egal ob Privatumzug, Firmenumzug oder internationaler Umzug, wir haben 
                  die passende Lösung für Ihre Bedürfnisse.
                </Typography>
                <Typography variant="body1" sx={{ color: 'white' }}>
                  Kontaktieren Sie uns noch heute für ein unverbindliches Angebot!
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default MovingService;